import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import Global from '../../store/global-selectors';

import type { Marketplace } from '@shipstation/client-common/types/reference-data';

const UNKNOWN_MARKETPLACE_ID = 0;

export type ConnectionLogoProps = { marketplaceId?: number; fillProviderId?: number };

type FulfillmentProvider = { apiCode: string; fillProviderId: number };

/**
 * Resolves a connection's `apiCode` against the marketplace and fulfillment-provider reference data so
 * `DataDrivenLogo` can find a brand mark, falling back to the unknown-marketplace icon. A connection can
 * be either kind, which is why this cannot be a plain lookup in one list.
 */
export const useConnectionLogoProps = () => {
  const marketplaces: Marketplace[] = useSelector(Global.selectReferenceDatagetMarketplaces);
  const fulfillmentProviders: FulfillmentProvider[] = useSelector(Global.selectReferenceDatagetFulfillmentProviders);

  return useCallback(
    (apiCode: string): ConnectionLogoProps => {
      const marketplace = marketplaces.find(({ apiCode: marketplaceApiCode }) => marketplaceApiCode === apiCode);
      if (marketplace) {
        return { marketplaceId: marketplace.marketplaceId };
      }

      const fulfillmentProvider = fulfillmentProviders.find(({ apiCode: providerApiCode }) => providerApiCode === apiCode);
      if (fulfillmentProvider) {
        return { fillProviderId: fulfillmentProvider.fillProviderId };
      }

      return { marketplaceId: UNKNOWN_MARKETPLACE_ID };
    },
    [marketplaces, fulfillmentProviders],
  );
};
